import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HowToRegIcon from '@mui/icons-material/HowToReg';

export const RotasSideBar = [
    {
        full_name: "CALENDARIO",
        roles: ["ROLE_CALENDARIO"],
        children: [
            {
                name: "Reservar",
                path: "/private/agenda/locais",
                pathSelected: "/private/agenda/",
                tittle: "Reservar",
                icon: <CalendarMonthIcon />,
                roles: ['ROLE_CALENDARIO']
            },
        ],
    },
    {
        full_name: "RESERVAS",
        roles: ["ROLE_RESERVAS"],
        children: [
            {
                name: "Minhas Reservas",
                path: "/private/reservas/minhasReservas",
                pathSelected: "/private/reservas/",
                tittle: "Minhas Reservas",
                icon: <HowToRegIcon />,
                roles: ['ROLE_RESERVAS']
            },
        ],
    }
];

